import React, { useRef, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Layout, Row } from "antd";
import { Footer as FooterComponent } from "./components/Footer";
import { useBoolean, useClickAway } from "ahooks";
import HeaderMain from "./components/Header/Header";
import { Breadcrumbs } from "./components/Breadcrumbs";
import { Routing } from "./components/Routing";
import styles from "./App.module.scss";
const { Footer } = Layout;

function App() {
  const divRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isMenuOpen, { toggle: toggleMenu, setFalse: hideMenu }] =
    useBoolean(false);
  const [isOutHeader, setOutHeader] = useState<boolean>(true);
  useClickAway(() => {
    isMenuOpen && hideMenu();
  }, [divRef, buttonRef]);

  const footerStyle: React.CSSProperties = {
    textAlign: "center",
    color: "#fff",
    backgroundColor: "#000",
    minHeight: 100,
  };

  return (
    <BrowserRouter>
      <Layout style={{ backgroundColor: "#fff" }}>
        <HeaderMain isOutHeader={isOutHeader} />

        <div
          onMouseEnter={() => {
            setOutHeader(true);
          }}
          onMouseLeave={() => {
            setOutHeader(false);
          }}
        >
          {" "}
          <div style={{ paddingTop: "80px" }}>
            <Breadcrumbs />
            <Routing />
          </div>
          <Footer style={footerStyle} className={styles.footer}>
            <FooterComponent />
          </Footer>
          <Footer>
            <Row
              align="middle"
              justify="center"
              className={styles.bottomFooter}
            >
              © HaltenTech {new Date().getFullYear()}
            </Row>
          </Footer>
        </div>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
